module.exports = __webpack_public_path__ + "media/images/contest-disabled-label-right-700fba5f93fec23e610c268c70e0215f.png";